import React from 'react';
import { Box, Slider, Typography, IconButton } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Fast from '../resources/gauge-high-svgrepo-com.svg';
import Slow from '../resources/gauge-low-svgrepo-com.svg';
import { FastRewind } from '@mui/icons-material';

const iconStyle = {
  width: '42px',
  height: '42px',
  objectFit: 'contain',
};

const PlaybackSlider = ({
  playbackRate,
  handlePlaybackRateChange,
  resetPlaybackRate,
  disabled = false,
  limits = [0.5, 1.5],
  step = 0.1,
  title = 'Adjust the speed of the playback',
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      {/* <Typography variant="body2" sx={{ mr: 2 }}>
        Speed:
      </Typography> */}
      <IconButton
        style={{
          opacity: disabled ? 0.3 : 1,
          filter: disabled ? 'grayscale(100%)' : 'none',
        }}
        title="Set playback speed to slow"
        // size="large"
        sx={{ p: 0, width: 32, height: 32 }}
        onClick={() => resetPlaybackRate(limits[0])}
        disabled={disabled}
      >
        <img src={Slow} alt="Slow" style={iconStyle} />
      </IconButton>
      {/* <Typography variant="body2" sx={{ mr: 2 }}>
        {limits[0]}x
      </Typography> */}

      <Slider
        title={title}
        min={limits[0]}
        max={limits[1]}
        step={step}
        value={playbackRate}
        onChange={handlePlaybackRateChange}
        valueLabelDisplay="auto"
        sx={{ flex: 1, mx: 4 }}
        disabled={disabled}
      />
      {/* 
      <Typography variant="body2" sx={{ ml: 2 }}>
        {limits[1]}x
      </Typography> */}
      <IconButton
        style={{
          opacity: disabled ? 0.3 : 1,
          filter: disabled ? 'grayscale(100%)' : 'none',
        }}
        title="Reset playback speed to original"
        onClick={() => resetPlaybackRate(limits[1])}
        disabled={disabled}
        sx={{ p: 0, width: 24, height: 24, mx: 2 }}
      >
        <img src={Fast} alt="Fast" style={iconStyle} />
      </IconButton>
    </Box>
  );
};

export default PlaybackSlider;
